import React from "react";
import "./style.scss";
import {useTranslation} from "react-i18next";

const MallStoreList = ({
  selectedStore,
  setSelectedStore,
  avlStores,
  maxlimit,
  selectedStoreUUIDList,
  setSelectedStoreList,
}) => {
  const {t} = useTranslation();
  const updateSelectedServiceTypes = (s) => {
    const selectedMallStoreList = selectedStore;
    const selectedStoreList = JSON.parse(JSON.stringify(selectedStoreUUIDList));
    const index = selectedMallStoreList
      ? selectedMallStoreList.findIndex((x) => x.uuid === s)
      : -1;

    if (index > -1 && selectedMallStoreList.length > 0) {
      selectedMallStoreList.splice(index, 1);
      selectedStoreList.splice(index, 1);
    } else {
      if (selectedMallStoreList.length < maxlimit) {
        const filteredArray = avlStores.filter((x) => x.uuid === s);
        selectedMallStoreList.push(filteredArray[0]);
        selectedStoreList.push(filteredArray[0]?.uuid);
      }
    }
    setSelectedStore(selectedMallStoreList);
    setSelectedStoreList(selectedStoreList);
  };
  return (
    <div className="mallstore-selection">
      <div className="mallstorelist-label">
        <label className="label"> {t("mallstorelist.label")}</label>
        <label className="selectmallstore-sub-label">
          ({t("selectmallstore.maxlimit")} {maxlimit} )
        </label>
      </div>

      <div className="mallStoreList">
        {avlStores.map((s) => (
          <div
            className="mallstore-option"
            onClick={() => {
              updateSelectedServiceTypes(s.uuid);
            }}
            key={s.uuid}
          >
            <input
              type="checkbox"
              className="service-label"
              value={s.uuid}
              checked={selectedStoreUUIDList.includes(s.uuid)}
              onChange={() => {}}
            ></input>
            <label className="service-label">{s.businessUnit}</label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MallStoreList;
